import {useQuery} from '@apollo/client';
import * as React from 'react';

import {Medida, composicao, formatarData, formatarPeso, formatarVariacao, variacaoDePeso} from '../anthropometrics';
import {QUERY_STUDENT_ANTHROPOMETRICS} from '../studentQueries';
import {StudentTheme} from '../studentTheme';

interface Data {
  anthropometrics?: Medida[] | null;
}

export const AnthropometricsScreen: React.FC<{theme: StudentTheme}> = ({theme}) => {
  const {data, loading, error, refetch} = useQuery<Data>(QUERY_STUDENT_ANTHROPOMETRICS);

  const medidas = data?.anthropometrics ?? [];

  if (loading && medidas.length === 0) return <p className="student-screen__estado">Carregando…</p>;

  if (error && medidas.length === 0) {
    return (
      <div className="student-screen__estado">
        <p>Não foi possível carregar as medidas.</p>
        <button type="button" className="student-app__retry" onClick={() => refetch()}>
          Tentar de novo
        </button>
      </div>
    );
  }

  if (medidas.length === 0) return <p className="student-screen__estado">Nenhuma medida registrada.</p>;

  return (
    <div className="records">
      {medidas.map((medida, indice) => {
        // A lista vem em ordem decrescente, entao a anterior e a proxima.
        const variacao = variacaoDePeso(medida, medidas[indice + 1]);
        const partes = composicao(medida);

        return (
          <article key={medida.id} className="record-card" style={{backgroundColor: theme.body, borderColor: theme.border}}>
            <div className="record-card__info">
              <h2 className="record-card__nome">{formatarData(medida.date)}</h2>
              {partes.length > 0 && (
                <span className="record-card__categoria" style={{color: theme.neutral}}>
                  {partes.map((p) => `${p.label}: ${p.valor}`).join(' · ')}
                </span>
              )}
            </div>

            <div className="record-card__marca">
              <strong style={{color: theme.primary}}>{formatarPeso(medida.weight)}</strong>
              {variacao !== null && (
                <span style={{color: theme.neutral}}>{formatarVariacao(variacao)}</span>
              )}
            </div>
          </article>
        );
      })}
    </div>
  );
};
